import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PaymentResource {
  private readonly baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {
  }

  createPaymentIntent(userId: string, packageId: string, billingInterval: string): Observable<{
    clientSecret: string;
    error?: string;
  }> {
    return this.http.post<{
    clientSecret: string;
    error?: string;
    }>(`${this.baseUrl}/public/payment/create`, { userId, packageId, billingInterval });
  }

  getPaymentStatus(intentId: string): Observable<{ status: string }> {
    return this.http.get<{ status: string }>(`${this.baseUrl}/public/payment/status/${intentId}`);
  }
  /**
   * Create a SetupIntent for saving customer payment method for subscriptions
   */
  createSetupIntent(userId: string): Observable<{ clientSecret: string }> {
    return this.http.post<{ clientSecret: string }>(
      `${this.baseUrl}/public/payment/setup-intent`,
      { userId }
    );
  }

  getPaymentMethod(): Observable<{ last4: string; expMonth: number; expYear: number; brand: string } | null> {
    return this.http.get<{ last4: string; expMonth: number; expYear: number; brand: string } | null>(
      `${this.baseUrl}/user/payment-method`
    );
  }

  updateCard(paymentMethodId: string): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/user/payment-method`, {paymentMethodId});
  }

  getPaymentMethodLast4(pmId: string): Observable<{ last4: string }> {
    return this.http.get<{ last4: string }>(`${this.baseUrl}/user/payment-method/${pmId}/last4`);
  }

  /**
   * Create a Subscription on the server using an attached payment method
   */
  createSubscription(
    userId: string,
    packageId: string,
    billingInterval: string,
    paymentMethodId: string,
    billingName?: string
  ): Observable<{
    subscriptionId: string;
    clientSecret?: string; // for first invoice payment
    status?: string;
  }> {
    return this.http.post<{
      subscriptionId: string;
      clientSecret?: string;
      status?: string;
    }>(
      `${this.baseUrl}/public/payment/subscription`,
      {userId, packageId, billingInterval, paymentMethodId, billingName}
    );
  }

}
